import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import cn from 'classnames';
import FormattedDate from "../FormattedDate";
import { DayjsFormatTypes } from "../utils";

/**
 * @deprecated Use FormattedDate instead
 */
var Moment = function Moment(_ref) {
  var date = _ref.date,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'muted' : _ref$color,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? DayjsFormatTypes.Date : _ref$format,
      _ref$humanize = _ref.humanize,
      humanize = _ref$humanize === void 0 ? false : _ref$humanize,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? undefined : _ref$variant;
  return React.createElement("div", {
    className: cn('d-flex moment-wrapper', _defineProperty({}, "text-".concat(color), color), className),
    style: style,
    "data-qa": "moment"
  }, humanize ? React.createElement(FormattedDate, {
    variant: variant,
    date: date,
    format: "humanized"
  }) : React.createElement(React.Fragment, null, format === DayjsFormatTypes.Time ? React.createElement(FormattedDate, {
    variant: variant,
    date: date,
    format: "time"
  }) : React.createElement(FormattedDate, {
    variant: variant,
    date: date,
    format: format
  })));
};

export default Moment;